<template>
  <v-content class="resume mb-16">
    <h1
      class="font-weight-thin d-flex justify-center"
      :class="this.$vuetify.breakpoint.smAndDown ? 'mt-8' : 'mt-16'"
    >
      IT Engineer
    </h1>
    <h2 class="font-weight-thin d-flex justify-center mb-8">
      Front-end Developer
    </h2>
    <!-- <h1 class="d-flex justify-center">Front-end Developper</h1> -->

    <v-row justify="center">
      <v-col cols="12" md="9" class="mb-8">
        <v-sheet class="py-2" tile :elevation="8">
          <v-row class="my-2" align="center">
            <v-col class="text-center" cols="12">
              <DownloadResume />
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <h2 class="font-weight-thin ml-4 my-8">Work Experience</h2>
          <v-card class="pl-8 pt-2 pb-2 pr-6" tile>
            <Experience
              v-for="experience in experiences"
              :key="'exp' + experience.id"
              :experience="experience"
            />
          </v-card>
          <v-divider></v-divider>
          <h2 class="font-weight-thin ml-4 my-8">Education</h2>
          <v-card class="pl-8 pt-2 pb-2 pr-6" tile>
            <Education
              v-for="education in degrees"
              :key="'ed' + education.id"
              :education="education"
            />
          </v-card>
          <v-divider></v-divider>
          <h2 class="font-weight-thin ml-4 my-8">Technologies</h2>
          <v-card class="pl-8 pt-2 pb-2 pr-6" tile>
            <TechnologiesTab :technologies="technologies" typeTech="Language" />
            <TechnologiesTab
              :technologies="technologies"
              typeTech="Framework / Library / CMS"
            />
          </v-card>
          <v-divider></v-divider>
          <h2 class="ml-4 font-weight-thin my-8">Other skills</h2>
          <v-card class="pl-8 pt-2 pb-2 pr-6" tile>
            <SkillsTab
              :softwares="softwares"
              :softSkills="softSkills"
              :spokenLanguages="spokenLanguages"
            />
          </v-card>
          <v-divider></v-divider>
          <v-row class="my-2" align="center">
            <v-col class="text-center" cols="12">
              <DownloadResume />
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </v-content>
</template>

<script>
import Experience from "@/components/Experience.vue";
import Education from "@/components/Education.vue";
import TechnologiesTab from "@/components/TechnologiesTab.vue";
import SkillsTab from "@/components/SkillsTab.vue";
import DownloadResume from "@/components/DownloadResume.vue";

export default {
  name: "Resume",
  components: {
    Experience,
    Education,
    TechnologiesTab,
    SkillsTab,
    DownloadResume,
  },
  data() {
    return {
      technologies: [
        {
          id: 0,
          name: "JavaScript",
          // Language, Library, Framework, Platform, Data
          type: "Language",
          // knowledge from 1 to 10
          knowledge: 4,
        },
        {
          id: 1,
          name: "CSS3",
          type: "Language",
          knowledge: 4,
        },

        {
          id: 2,
          name: "HTML5",
          type: "Language",
          knowledge: 4,
        },
        {
          id: 3,
          name: "Java",
          // Language, Library, Framework, Platform, Data
          type: "Language",
          // knowledge from 1 to 10
          knowledge: 3,
        },
        {
          id: 4,
          name: "VBA Excel",
          // Language, Library, Framework, Platform, Data
          type: "Language",
          // knowledge from 1 to 10
          knowledge: 3,
        },
        {
          id: 5,
          name: "SQL",
          // Language, Library, Framework, Platform, Data
          type: "Language",
          // knowledge from 1 to 10
          knowledge: 2,
        },
        {
          id: 6,
          name: "Python",
          // Language, Library, Framework, Platform, Data
          type: "Language",
          // knowledge from 1 to 10
          knowledge: 1,
        },
        {
          id: 7,
          name: "PHP",
          // Language, Library, Framework, Platform, Data
          type: "Language",
          // knowledge from 1 to 10
          knowledge: 1,
        },
        {
          id: 8,
          name: "Vue.js",
          // Language, Library, Framework, Platform, Data
          type: "Framework / Library / CMS",
          // knowledge from 1 to 10
          knowledge: 6,
        },
        {
          id: 9,
          name: "Vuetify",
          // Language, Library, Framework, Platform, Data
          type: "Framework / Library / CMS",
          // knowledge from 1 to 10
          knowledge: 5,
        },
        {
          id: 10,
          name: "Magento",
          // Language, Library, Framework, Platform, Data
          type: "Framework / Library / CMS",
          // knowledge from 1 to 10
          knowledge: 5,
        },
        {
          id: 11,
          name: "WordPress",
          // Could also be Flask
          // Language, Library, Framework, Platform, Data
          type: "Framework / Library / CMS",
          // knowledge from 1 to 10
          knowledge: 5,
        },
        {
          id: 12,
          name: "React",
          // Language, Library, Framework, Platform, Data
          type: "Framework / Library / CMS",
          // knowledge from 1 to 10
          knowledge: 4,
        },
        {
          id: 13,
          name: "jQuery",
          // Language, Library, Framework, Platform, Data
          type: "Framework / Library / CMS",
          // knowledge from 1 to 10
          knowledge: 4,
        },
        {
          id: 14,
          name: "Bootstrap",
          // Language, Library, Framework, Platform, Data
          type: "Framework / Library / CMS",
          // knowledge from 1 to 10
          knowledge: 4,
        },
        {
          id: 15,
          name: "Django",
          // Could also be Flask
          // Language, Library, Framework, Platform, Data
          type: "Framework / Library / CMS",
          // knowledge from 1 to 10
          knowledge: 2,
        },
      ],
      experiences: [
        {
          id: 0,
          positionTitle: "Customer Journey Specialist & Front-end Developer",
          jobDescription:
            "Analysis of Customer Data, conception, and development of new features via Magento for the website kayme.com",
          compagnyName: "kay me",
          address: {
            city: "Tokyo",
            country: "Japan",
          },
          startDate: "2020-04-01",
          endDate: "2021-07-09",
          // endDate: this.today(),
        },
        {
          id: 1,
          positionTitle: "Front-end Developer Vue.js (Part-time Job)",
          jobDescription:
            "Developing an application Indeed Like for internal customers",
          compagnyName: "Japan Info",
          address: {
            city: "Tokyo",
            country: "Japan",
          },
          startDate: "2019-11-01",
          endDate: "2020-03-31",
        },
        {
          id: 2,
          positionTitle:
            "HRIS Project Manager Assistant on HR Referential (Apprenticeship)",
          jobDescription:
            "Improving the quality of employee data and managing HR information systems",
          compagnyName: "Louis Vuitton",
          address: {
            city: "Paris",
            country: "France",
          },
          startDate: "2017-09-01",
          endDate: "2018-08-31",
        },
        {
          id: 3,
          positionTitle: "Mainframe Project Manager Assistant (Apprenticeship)",
          jobDescription:
            "Analysing, designing and maintaining cash pooling applications",
          compagnyName: "BNP Paribas",
          address: {
            city: "Montreuil",
            country: "France",
          },
          startDate: "2014-09-01",
          endDate: "2016-08-31",
        },
        {
          id: 4,
          positionTitle: "Developer at the Payroll Department (Apprenticeship)",
          jobDescription:
            "Coding Visual Basic for Applications tools on Excel to help internal customers in their daily tasks",
          compagnyName: "Société Générale",
          address: {
            city: "Fontenay-sous-Bois",
            country: "France",
          },
          startDate: "2014-09-01",
          endDate: "2016-08-31",
        },
      ],
      degrees: [
        {
          id: 0,
          degree: "IT Engineer Degree",
          courseName: "Engineering in Information System",
          trainingDescription:
            "Advanced Programming (Java), Web & Mobile Information Systems, Artificial Intelligence, Database Architecture, Introduction in Cloud Computing, Business Intelligence, ITIL",
          schoolName: "Conservatoire National des Arts et Métiers (CNAM)",
          address: {
            city: "Paris",
            country: "France",
          },
          startDate: "2014-09-01",
          endDate: "2018-08-31",
        },
        {
          id: 1,
          degree: "Technology University Degree",
          courseName: "Technology University of Information Systems",
          trainingDescription:
            "Algorithms, Data Base, Programming, Operating Systems, Security and Networks",
          schoolName: "IUT de Montreuil",
          address: {
            city: "Paris",
            country: "France",
          },
          startDate: "2011-09-01",
          endDate: "2014-08-31",
        },
      ],
      softwares: [
        {
          id: 0,
          name: "Git(Hub)",
          description: "Code Versionning System",
        },
        {
          id: 1,
          name: "Firebase",
          description: "Mobile and web application development platform",
        },
        {
          id: 2,
          name: "Unified Modeling Language",
          description:
            "To define diagrams allowing the visualization of behavior and states in systems.",
        },
        {
          id: 3,
          name: "Office Suite",
          description: "Contains Excel, PowerPoint, Word etc.",
        },
        {
          id: 4,
          name: "Slack",
          description: "Instant messaging platform for team work",
        },
      ],
      softSkills: [
        {
          id: 0,
          name: "Curiosity",
          explanation: "Love to dive more into depth of any topic I work for",
        },
        {
          id: 1,
          name: "Creativity",
          explanation:
            "From Curiosity born Creativity, and this is why I'm always looking for something innovative",
        },
        {
          id: 2,
          name: "Teamwork",
          explanation:
            "Because learning come from sharing with others, setting up a good atmosphere alongside with great collaborations is one of my priorities",
        },
        {
          id: 3,
          name: "Self-improvement",
          explanation: "Always trying to take a step back to surpass myself",
        },
      ],
      spokenLanguages: [
        {
          id: 0,
          name: "French",
          level: "Native",
          certificate: null,
        },
        {
          id: 1,
          name: "English",
          level: "Fluent",
          certificate: null,
        },
        {
          id: 2,
          name: "Japanese",
          level: "Equivalent N3 or B1/B2",
          certificate: null,
        },
        {
          id: 3,
          name: "Spanish",
          level: "Good working knowledge",
          certificate: null,
        },
      ],
    };
  },
  methods: {
    today() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },
  },
};
</script>
